<template>
  <div class="order-submission">
    <h6>请确认以下产品信息</h6>
    <div class="content">
      <div class="title">产品信息</div>
      <PackageInformation :productData="productData" @promoCodeBlur="promoCodeBlur"/>
      <div class="action-bar">
        <div class="service-agreement">
          <span>服务协议</span>
          <el-checkbox
            v-if="rnewCheckBox"
            @change="checkboxChange"
            :value="checked"
          ></el-checkbox>
          <strong>我已阅读并同意</strong>
          <b
            v-for="(item, index) in agreements"
            @click="agreementClick(item, index)"
            :key="item.name"
            >《{{ item.name }}》{{
              index + 1 < agreements.length ? '、' : ''
            }}</b
          >
        </div>
        <div class="btn">
          <el-button
            type="primary"
            @click="submit"
            :disabled="!checked"
            :loading="loading"
            >确认订单</el-button
          >
        </div>
      </div>
    </div>
    <ServiceAgreement
      ref="orderSubmissionServiceAgreement"
      v-if="serviceAgreementShow"
      @close="serviceAgreementClose"
      :agreements="agreements"
      :index="agreementIndex"
    />
  </div>
</template>

<script>
import ServiceAgreement from '@/components/common/ServiceAgreement'
import PackageInformation from './components/PackageInformation'
import { getSubscribeKitList, createOrder } from '@/utils/api/order'
import { mapState, mapMutations } from 'vuex'
import getAgreementMinxins from '@/mixins/getAgreement'
export default {
  components: {
    PackageInformation,
    ServiceAgreement,
  },
  mixins: [getAgreementMinxins],
  computed: {
    ...mapState('orderInfo', ['packages']),
    ...mapState('serviceAgreement', ['agreementList']),
    ...mapState(['userInfo']),
  },
  data() {
    return {
      checked: false,
      serviceAgreementShow: false,
      productData: {},
      agreements: [],
      consentTime: null,
      rnewCheckBox: true,
      loading: false,
      agreementIndex: undefined,
      promoCode:''
    }
  },
  methods: {
    ...mapMutations('orderInfo', ['SET_PACKAGES']),
    ...mapMutations('serviceAgreement', ['SET_AGREEMENT_LIST']),
    async promoCodeBlur(value){
      this.promoCode=value
      try {
        const params={
            promoCode:this.promoCode,
            kitName:this.productData.kitName,
          }
        const res = await getSubscribeKitList(params)
        if (res.rspResult.bizCode === 200) {
          let list = res.rspListData.list
          this.SET_PACKAGES(list || null)
          this.productData = list[this.$route.query.type || 0]
        }
      } catch (err) {
        console.error(
          '❌ ~ file: order-submission.vue:161 ~ created ~ err:',
          err
        )
      }
    },
    async submit() {
      this.loading = true
      const _remark = this.userInfo.leadsStatus != 8 ? 
        '海智铂金会员，钻石会员，VIP会员，VVIP会员限时特惠' :
        '海智老朋友限时体验价'
      try {
        const res = await createOrder({
          kitName: this.productData.kitName,
          remark: _remark,
          promoCode:this.promoCode,
          agreements: this.agreements.map((ele) => {
            return {
              agreementType: ele.type,
              agreementName: ele.name,
              version: ele.version,
              agreeTime: this.consentTime,
              agreementUrl: ele.url,
            }
          }),
        })
        if (res.rspResult.bizCode === 200) {
          this.$router.push({
            path: `order-payment/${res.data.orderNo}`,
          })
        } else if (res.rspResult.bizCode === 5030) {
          this.$confirm(
            '如需帮助，请联系您的客户经理',
            '当前产品仅支持海智数采宝钻石会员，铂金会员，VIP会员及VVIP会员购买',
            {
              confirmButtonText: '我知道了',
              center: true,
              showCancelButton: false,
              customClass: 'order-submission-contract-btn',
            }
          )
          .then(() => {
            // 从哪来的回哪去, 默认回到我的订单页
            this.$router.push({
              name:
                this.$route.query.origin == 1
                  ? 'const-center-meal-choose'
                  : 'const-center-my-order',
            })
          })
          .catch(() => {
          })
          this.loading = false
        } else {
          this.$message.error(res.rspResult.message)
          this.loading = false
        }
      } catch (err) {
        console.error(
          '❌ ~ file: order-submission.vue:124 ~ submit ~ err:',
          err
        )
        this.loading = false
      }
    },
  },
  async created() {
    this.getAgreementList()
    // 💣💣💣价格会根据leadsStatus动态变化，所以必须每次重新请求
    if (false && this.packages && this.packages.length) {
      // 默认从vuex取
      this.productData = this.packages[this.$route.query.type || 0]
    } else {
      // 如果取不到，请求后端
      try {
        const res = await getSubscribeKitList()
        if (res.rspResult.bizCode === 200) {
          let list = res.rspListData.list
          this.SET_PACKAGES(list || null)
          this.productData = list[this.$route.query.type || 0]
        }
      } catch (err) {
        console.error(
          '❌ ~ file: order-submission.vue:161 ~ created ~ err:',
          err
        )
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.order-submission {
  padding-top: 40px;
  > h6 {
    width: 1040px;
    margin: 0 auto;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
    letter-spacing: 0;
    height: 16px;
    margin-bottom: 20px;
  }
  .content {
    width: 1040px;
    margin: 0 auto;
    .title {
      height: 48px;
      line-height: 48px;
      background: #ffffff;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4f5d78;
      letter-spacing: 0;
      padding-left: 24px;
      margin-bottom: 2px;
    }
    .action-bar {
      margin-top: 8px;
      background: #ffffff;
      padding: 20px 24px;
      .service-agreement {
        display: flex;
        margin-bottom: 28px;
        align-items: center;
        ::v-deep .el-checkbox__input {
          height: 14px;
          line-height: 14px;
          display: flex;
          align-items: center;
        }
        > span {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          letter-spacing: 0;
          margin-right: 40px;
          height: 14px;
          line-height: 14px;
        }
        > strong {
          color: #16181aff;
          font-size: 14px;
          font-weight: 400;
          height: 14px;
          line-height: 14px;
          margin-left: 8px;
        }
        > b {
          cursor: pointer;
          color: #066eb7ff;
          font-size: 14px;
          height: 14px;
          line-height: 14px;
          margin-left: 6px;
        }
      }
      .btn {
        text-align: right;
        .el-button {
          width: 128px;
          height: 40px;
          font-size: 14px;
        }
        .is-disabled {
          background: #cfd5df;
          color: #ffffff;
          border: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.order-submission-contract-btn {
  width: 566px;
  padding-bottom: 50px;
  .el-message-box__close {
    margin-top: 16px;
    margin-right: 17px;
  }
  .el-message-box__title {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #16181a;
  }
  .el-message-box__message {
    color: #4f5d78;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
  }
  .el-message-box__btns {
    .el-button {
      width: 216px;
      margin-top: 20px;
    }
  }
  .el-message-box__header {
    padding-top: 50px;
  }
  .el-message-box__headerbtn {
    top: -3px;
    right: 0px;
  }
}
</style>
